import { Action } from '../../core/action'
import { CreateResponse, ListResponse } from '../../types/crud'
import { ProjectListOpts, ProjectResourceBrief } from '../../types/resources/project'

export const projects = {
  // Actions
  list: new Action<[ProjectListOpts], ListResponse<ProjectResourceBrief>>(),
  create: new Action<[any], CreateResponse<any>>(),
} as const
